import { Box, Chip, ChipProps, Tooltip } from '@mui/material'
import { OverflowCountBadge } from './OverflowCountBadge'

export { OverflowCountBadge } from './OverflowCountBadge'
export type { OverflowCountBadgeProps } from './OverflowCountBadge'

export type ChipListItem = Omit<ChipProps, 'label'> & {
  label: string | number
  tooltipLabel?: string | number
}

export type ChipListProps = {
  chips: ChipListItem[]
  maxChips?: number
  /** Includes items omitted from `chips`, such as a server-provided preview. */
  totalCount?: number
}

export const ChipList = ({ chips, maxChips = 3, totalCount }: ChipListProps) => {
  const visibleChips = chips.slice(0, Math.max(0, maxChips))
  const hiddenChips = chips.slice(visibleChips.length)
  const hiddenCount = Math.max(0, (totalCount ?? chips.length) - visibleChips.length)
  const hiddenTitles = hiddenChips.map((chip) => chip.tooltipLabel ?? chip.label).join(', ')

  return (
    <Box
      sx={{
        display: 'grid',
        gridAutoFlow: 'column',
        gridAutoColumns: 'minmax(0, max-content)',
        columnGap: 1,
        alignItems: 'center',
        minWidth: 0,
      }}
    >
      {visibleChips.map(({ tooltipLabel, ...chipProps }, index) => (
        <Tooltip key={index} title={tooltipLabel ?? chipProps.label}>
          <Chip {...chipProps} />
        </Tooltip>
      ))}
      <OverflowCountBadge count={hiddenCount} hint={hiddenTitles} />
    </Box>
  )
}
